import { Link } from 'react-router';

import { cn } from '@april9au/react-common/utils';

export type CtaLink = {
  label: string;
  to: string;
};

function isExternalHref(to: string) {
  return /^(mailto:|tel:|https?:)/.test(to);
}

/**
 * Renders a marketing CTA using the `.btn` classes defined in app.css (per
 * its own guidance, those — not the shadcn `<Button>` — are for hero/footer/nav
 * style CTAs). Resolves to an internal route Link, or a plain anchor for
 * mailto:/tel:/external URLs.
 *
 * `variant="rule"` renders the quiet reading-action style instead (sentence
 * case on a gold underline, no button chrome) — used for secondary actions
 * that shouldn't compete with a page's one primary button.
 */
export function CtaLinkButton({
  cta,
  variant = 'primary',
  size,
  className,
}: {
  cta: CtaLink;
  variant?: 'primary' | 'secondary' | 'rule';
  size?: 'sm' | 'lg';
  className?: string;
}) {
  const classes =
    variant === 'rule'
      ? cn('link-rule', className)
      : cn('btn', variant === 'primary' ? 'btn--primary' : 'btn--secondary', size && `btn--${size}`, className);

  return isExternalHref(cta.to) ? (
    <a href={cta.to} className={classes}>
      {cta.label}
    </a>
  ) : (
    <Link to={cta.to} className={classes}>
      {cta.label}
    </Link>
  );
}
